import { PositionCode } from '@rendora/common/entities/analysis_backend';
import { defineStore } from 'pinia';
import { reactive } from 'vue';

export interface QRCodeData {
  live_code: string;
  link: string;
  timestamp: number;
  status?: 'active' | 'expired' | 'error';
}

export interface QRCodeStore {
  [key: string]: QRCodeData;
}

export const useContactStore = defineStore('contact', () => {
  const qrCodeData = reactive<QRCodeStore>({});
  const getQrCodeData = (code: PositionCode) => {
    return qrCodeData[code];
  };
  const setQrCodeData = (code: PositionCode, data: QRCodeData) => {
    qrCodeData[code] = data;
  };
  return {
    qrCodeData,
    getQrCodeData,
    setQrCodeData,
  };
});
